"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var app_const_1 = require("./app.const");
/**
 * AppService
 * @class
 */
var AppService = /** @class */ (function () {
    function AppService() {
    }
    /**
     * Returns a list of countries available for a client application
     */
    AppService.prototype.getCountries = function (version) {
        if (version === void 0) { version = 'v1'; }
        var url = app_const_1.APP_ENDPOINT.getCountries.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a list of operators in each country available for a given service
     * @param service {string}
     */
    AppService.prototype.getOperatorsByCountries = function (service, version) {
        if (version === void 0) { version = 'v1'; }
        var url = app_const_1.APP_ENDPOINT.getOperatorsByCountries
            .replace('{{version}}', version)
            .replace('{{service}}', service);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns an API Key for a given consumer (company)
     * @param companyUuid {string}
     */
    AppService.prototype.getSearchApiKey = function (companyUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = app_const_1.APP_ENDPOINT.getSearchApiKey
            .replace('{{version}}', version)
            .replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return AppService;
}());
/**
 * External AppService Class Instance
 * @namespace
 */
exports.app = new AppService();
